import React, { SVGProps } from 'react';

const ChevronArrowIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 7 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.833984 9.00055L4.83398 5.00055L0.833984 1.00055L1.77679 0.0577421L6.2482 4.52915C6.50855 4.7895 6.50855 5.21161 6.2482 5.47195L1.77679 9.94336L0.833984 9.00055Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default ChevronArrowIcon;
